// extracted by css-extract-rspack-plugin
export default {"sale":"wpGGkd"};